module.exports = __webpack_public_path__ + "media/images/about-us/Headshots/Tiffany Drouillard-6ea89c0c1c2d4fef8bf1407283512195.png";